module.exports = __webpack_public_path__ + "static/media/tractor.bc6891ae.svg";